<div class="thanks-modal" (click)="close()">
  <!-- Confetti particles -->
  <div class="thanks-modal__confetti">
    <span *ngFor="let p of [1,2,3,4,5,6,7,8]" class="particle particle--{{p}}"></span>
  </div>
  
  <!-- Success checkmark -->
  <div class="thanks-modal__check">
    <svg viewBox="0 0 52 52">
      <circle cx="26" cy="26" r="25" fill="none"/>
      <path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
    </svg>
  </div>
  
  <!-- Content -->
  <p class="thanks-modal__title">¡Gracias!</p>
  <p class="thanks-modal__message">{{ selectedMessage }}</p>
  
  <!-- Stars -->
  <div class="thanks-modal__stars">
    <span *ngFor="let i of [1,2,3,4,5]" 
          class="thanks-modal__star" 
          [class.filled]="i <= stars"
          [style.animation-delay]="(i * 0.1) + 's'">★</span>
  </div>
</div>
